import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "SimNao"
})
export class SimNaoPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    return value ? "SIM" : "NÃO";
  }
}